import { useEffect, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPlatforms } from 'src/api';
import { platformKeys } from 'src/utils/query-keys';
import { isSuccessResponse } from 'src/utils/response-type-guards';
import { useAuthContext } from 'src/auth/hooks';
import {
  getCachedPlatforms,
  getCachedPlatformsUpdatedAt,
  setCachedPlatforms,
} from 'src/utils/platform-cache';

const PLATFORMS_STALE_TIME = 5 * 60 * 1000;

export const usePlatforms = () => {
  const { authenticated } = useAuthContext();
  const { data, isLoading } = useQuery({
    queryKey: platformKeys.list(),
    queryFn: getPlatforms,
    retry: 2,
    enabled: authenticated,
    staleTime: PLATFORMS_STALE_TIME,
    initialData: getCachedPlatforms,
    initialDataUpdatedAt: getCachedPlatformsUpdatedAt,
  });

  const platforms = useMemo(() => (data && isSuccessResponse(data) ? data || [] : []), [data]);

  useEffect(() => {
    if (platforms.length > 0) {
      setCachedPlatforms(platforms);
    }
  }, [platforms]);

  return {
    data: platforms,
    isLoading,
  };
};
